export { default } from "@suid/styled-engine/createStyle";
export const resolvedPropKey = "__resolved";
